import { IConfiguredHttp } from './http';

export interface IBookingPaymentApi {
	requestBookingPayment(propertyId: number | string, eventId: string): Promise<{}>;
}

const bookingPaymentApiFactory = (http: IConfiguredHttp, prefix = ''): IBookingPaymentApi => ({
	async requestBookingPayment(propertyId, eventId) {
		const response = await http.post(`${prefix}/property/${propertyId}/event/${eventId}`);
		if (!response) {
			throw new Error('Failure requesting payment');
		}
		return response;
	}
});

export default bookingPaymentApiFactory;
